import { render, staticRenderFns } from "./AppHeaderBar.vue?vue&type=template&id=978a512c"
import script from "./AppHeaderBar.vue?vue&type=script&lang=js"
export * from "./AppHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderBar.vue?vue&type=style&index=0&id=978a512c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports